import { DecodedToken } from '@core/models';
import { TenantModel } from '@core/models/auth/tenant.model';
import { AuthenticateUserCommand, ResetPasswordCommand, RequestPasswordResetCommand, QrCodeSetupModel, PinRequestModel } from '@core/services/api.service';

export class LoginAction {
  static readonly type = '[Auth] Login';

  constructor(public payload: { authenticateUserCommand: AuthenticateUserCommand, redirectUrl?: string }) { }
}

export class LoginSuccessAction {
  static readonly type = '[Auth] Login Success';

  constructor(public payload: { decodedToken: DecodedToken, redirectUrl?: string }) { }
}

export class LoginFailAction {
  static readonly type = '[Auth] Login Fail';
}

export class ClearTokenAction {
  static readonly type = '[Auth] Clear Token';
}

export class ClearLastUserAction {
  static readonly type = '[Auth] Clear Last User';
}

export class RequestForgotenPasswordAction {
  static readonly type = '[Users] Request Forgoten Password';

  constructor(public payload: { requestPasswordResetCommand: RequestPasswordResetCommand }) { }
}

export class RequestForgotenPasswordSuccessAction {
  static readonly type = '[Auth] Request Forgoten Password Success';

  constructor(public payload: { email: string }) { }
}

export class RequestForgotenPasswordFailAction {
  static readonly type = '[Auth] Request Forgoten Password Fail';
}

export class ResetForgotenPasswordAction {
  static readonly type = '[Auth] Reset Forgoten Password';

  constructor(public payload: { resetPasswordCommand: ResetPasswordCommand }) { }
}

export class ResetForgotenPasswordSuccessAction {
  static readonly type = '[Auth] Reset Forgoten Password Success';

  constructor(public payload: { username: string }) { }
}

export class ResetForgotenPasswordFailAction {
  static readonly type = '[Users] Reset Forgoten Password Fail';
}

export class ChangeTenantAction {
  static readonly type = '[Auth] Change Tenant';

  constructor(public payload: { tenant: TenantModel }) { }
}

// Authentication
export class LoadHasAuthenticatorConfiguredAction {
    static readonly type = '[Auth] Load Has  Authenticator Configured';

    constructor(public payload: { username: string }) { }
}

export class LoadHasAuthenticatorConfiguredSuccessAction {
    static readonly type = '[Auth] Load Has  Authenticator Configured Success';

    constructor(public payload: { hasAuthenticatorConfigured: boolean }) { }
}

export class LoadHasAuthenticatorConfiguredFailAction {
    static readonly type = '[Auth] Load Has  Authenticator Configured Fail';
}

//Register Authentication
export class RegisterAuthenticatorAction {
    static readonly type = '[Auth] Register  Authenticator';
    constructor(public payload: { username: string }) { }
}

export class RegisterAuthenticatorSuccessAction {
    static readonly type = '[Auth] Register  Authenticator Success';

    constructor(public payload: { qrCodeSetupModel: QrCodeSetupModel }) { }
}

export class RegisterAuthenticatorFailAction {
    static readonly type = '[Auth] Register  Authenticator Fail';
}

//UnregisterAuthenticator
export class UnRegisterAuthenticatorAction {
    static readonly type = '[Auth] UnRegister  Authenticator';
    constructor(public payload: { username: string }) { }
}

export class UnRegisterAuthenticatorSuccessAction {
    static readonly type = '[Auth] UnRegister  Authenticator Success';
}

export class UnRegisterAuthenticatorFailAction {
    static readonly type = '[Auth] UnRegister  Authenticator Fail';
}


//login with auth
export class UnlockAccountWithAuthenticatorAction {
    static readonly type = '[Auth] Unlock Account With Authenticator';

    constructor(public payload: { pin: number, key: string }) { }
}

export class UnlockAccountWithAuthenticatorSuccessAction {
    static readonly type = '[Auth] Unlock Account With Authenticator Success';
}

export class UnlockAccountWithAuthenticatorFailAction {
    static readonly type = '[Auth] Unlock Account With Authenticator Fail';
}

// CreateAuthenticatorPinRequest

export class CreateAuthenticatorPinRequestAction {
    static readonly type = '[Auth] Create Authenticator Pin Request';

    constructor(public payload: { username: string }) { }
}

export class CreateAuthenticatorPinRequestSuccessAction {
    static readonly type = '[Auth] Create Authenticator Pin Request Success';

    constructor(public payload: { pinRequestModel: PinRequestModel }) { }
}

export class CreateAuthenticatorPinRequestFailAction {
    static readonly type = '[Auth] Create Authenticator Pin Request Fail';
}

//enable/disable 2fa
export class EnableDisable2FAAction {
    static readonly type = '[Auth] Enable or Disable 2FA';

    constructor(public payload: { username: string, enabled: boolean }) { }
}

export class EnableDisable2FASuccessAction {
    static readonly type = '[Auth] Enable or Disable 2FA Success';
}

export class EnableDisable2FAFailAction {
    static readonly type = '[Auth] Enable or Disable 2FA Fail';
}


//Has 2FA Enabled
export class Has2FAEnabledAction {
    static readonly type = '[Auth] Has 2FA Enabled';

    constructor(public payload: { username: string }) { }
}

export class Has2FAEnabledSuccessAction {
    static readonly type = '[Auth] Has 2FA Enabled Success';

    constructor(public payload: { has2FAEnabled: boolean }) { }
}

export class Has2FAEnabledFailAction {
    static readonly type = '[Auth] Has 2FA Enabled Fail';
}


//reset password with auth
export class ResetPasswordWithAuthenticatorAction {
    static readonly type = '[Auth] Reset Password With Authenticator';

    constructor(public payload: { pin: number, key: string }) { }
}

export class ResetPasswordWithAuthenticatorSuccessAction {
    static readonly type = '[Auth] Reset Password With Authenticator Success';
}

export class ResetPasswordWithAuthenticatorFailAction {
    static readonly type = '[Auth] Reset Password With Authenticator Fail';
}


//Is Account Locked
export class LoadIsAccountLockedAction {
    static readonly type = '[Auth] Is Account Locked';

    constructor(public payload: { username: string }) { }
}

export class LoadIsAccountLockedSuccessAction {
    static readonly type = '[Auth] Is Account Locked Success';

    constructor(public payload: { isAccountLocked: boolean }) { }
}

export class LoadIsAccountLockedFailAction {
    static readonly type = '[Auth] Is Account Locked Fail';
}


//Unlock account
export class UnlockAccountAction {
    static readonly type = '[Auth] Unlock Account';
    constructor(public payload: { username: string, islocked: boolean }) { }
}

export class UnlockAccountSuccessAction {
    static readonly type = '[Auth] Unlock Account Success';
}

export class UnlockAccountFailAction {
    static readonly type = '[Auth] Unlock Account Fail';
}
